/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    const d6 = "0.######";
    export const TiltRegex = /^tilt[0-9]+$/i;

    type MyItem = ModelTargetRow & AccountModelTargetRow & { __override?: Q.Dictionary<boolean>; __orig?: any };

    export interface AccountModelTargetRow {
        TargetName?: string;
    }

    export interface AccountModelTargetGridOptions {
        modelCode: string;
        modelName: string;
        accountCode?: string;
    }

    @Serenity.Decorators.registerClass()
    export class AccountModelTargetGrid extends SiteEntityGrid<MyItem, AccountModelTargetGridOptions> {
        protected getColumnsKey() { return 'Data.AccountModelTarget'; }
        protected getDialogType() { return AccountModelTargetDialog; }
		protected getIdProperty() { return ModelTargetRow.Fields.TargetCode; }
        protected getLocalTextPrefix() { return AccountModelTargetRow.localTextPrefix; }
        protected getService() { return ModelTargetService.baseUrl; }

		private model: Serenity.LookupEditor;
        private account: Serenity.LookupEditor;
        private expandTo: ExpandToLevelEditor;

		private editingHelper: GridEditingHelper;
        private pendingChanges: Q.Dictionary<any> = {};

        private isPercent: boolean;
        private activeRow: number;
        private focusToKey: string;
        private focusToKeys: Q.Dictionary<boolean>;
        private pendingApproval: boolean;
        private pendingResponse: AccountModelTargetIsPendingApprovalResponse = {};

        constructor(container: JQuery, options: AccountModelTargetGridOptions) {
			super(container, options);

			this.model = Serenity.Widget.create({
				type: FormatLookupEditor,
				options: {
					lookupKey: ModelRow.lookupKey
				},
				init: ed => {
					var first = this.options.modelCode ? ModelRow.getLookup().itemById[this.options.modelCode] :
                        ModelRow.getLookup().items[0];
                    if (first) {
						ed.value = first.ModelCode;
                        if (this.expandTo)
                            this.expandTo.modelCode = first.ModelCode;
                    }
				},
				element: el => el.attr('placeholder', '-- Model --')
					.css('float', 'left')
					.css('width', '350px')
					.insertAfter(this.toolbar.element.find('.s-QuickSearchBar'))
			});

            this.model.changeSelect2(e => {
                this.refresh();
                this.expandTo.modelCode = this.model.value;
                this.isPercent = !this.model.value || (ModelRow.getLookup().itemById[this.model.value]?.IsPercent ?? true);
            });

			this.account = Serenity.Widget.create({
				type: FormatLookupEditor,
				options: {
					lookupKey: AccountRow.lookupKey
				},
                init: ed => {
                    if (this.options.accountCode)
                        ed.value = this.options.accountCode;
				},
				element: el => el.attr('placeholder', '-- Account --')
					.css('float', 'left')
					.css('width', '300px')
					.insertAfter(this.model.element)
			});

            this.account.changeSelect2(e => this.refresh());

            this.isPercent = !this.options.modelCode || (ModelRow.getLookup().itemById[this.options.modelCode]?.IsPercent ?? true);

            if (this.options.modelCode) {

                AccountModelTargetService.List({
                    DistinctFields: [AccountModelTargetRow.Fields.AccountCode],
                    EqualityFilter: <AccountModelTargetRow>{
                        ModelCode: this.options.modelCode
                    }
                }, response => {
                        var match: Q.Dictionary<boolean> = {};
                    for (var x of response.Values || []) {
                        match[x] = true;
                        }
                        var index: Q.Dictionary<number> = {};
                        var next = 0;
                        for (var i of this.account.items) {
                            index[i.id] = next++;
                        }

                        this.account.items.sort((a, b) => {
                            var ma = match[a.id];
                            var mb = match[b.id];
                            if ((ma && mb) || (!ma && !mb)) {
                                var diff = index[a.id] - index[b.id];
                                return diff < 0 ? -1 : (diff > 0 ? 1 : 0);
                            }
                            if (ma)
                                return -1;
                            return 1;
                    });

                    this.account.element.data('select2').opts.formatResultCssClass = item => {
                        if (!match[item.id])
                            return "no-match-account";
                    };

                    if (this.account.items.length && !this.options.accountCode) {
                        this.account.value = this.account.items[0].id;
                    }
                }, { async: false});
            }

            this.expandTo = Serenity.Widget.create({
                type: ExpandToLevelEditor,
                element: el => el.css('float', 'left')
                    .css('width', '150px')
                    .css('margin-right', "0")
                    .insertAfter(this.account.element)
            });

            this.expandTo.modelCode = this.model.value;

            this.expandTo.changeSelect2(e => {
                var level = Q.toId(this.expandTo.value);
                if (level != null)
                    this.expandToLevel(level);
            });

            new Serenity.TreeGridMixin({
                grid: this,
                getParentId: x => this.getParentId(x),
                initialCollapse: () => {
                    var expandTo = Q.toId(this.expandTo.value);
                    if (expandTo == null || expandTo == -1)
                        return false;

                    if (expandTo == 0)
                        return true;

                    window.setTimeout(() => this.expandToLevel(expandTo));
                    return true;
                    
                },
				toggleField: "TargetCode"
			});

            this.element.addClass('editable-data-grid');
			this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
			this.editingHelper = new GridEditingHelper(this.element, this.slickGrid, true);

            this.element.find('.grid-container').on('focus', '.edit:input', e => {
                var cell = this.slickGrid.getCellFromEvent(e);
                if (cell.row != this.activeRow) {
                    this.activeRow = cell.row;
                    this.slickGrid.invalidate();
                    $(this.slickGrid.getCellNode(cell.row, cell.cell)).find(':input').eq(0).focus();
                    
                }
            });

            if (this.options.modelCode) {
                this.model.element.prev().hide();
                this.setTitle(this.getTitle() + ": " + this.options.modelCode + " - " + (this.options.modelName || ""));
            }

            var uploadButton = this.toolbar.findButton("add-file-button");
            if (Authorization.hasPermission('DataAdmin:AccountModelTarget')) {
                Serenity.UploadHelper.addUploadInput({
                    container: uploadButton,
                    inputName: this.uniqueName + '_UploadButton1',
                    fileDone: (response, name, data) => {
                        var fileName = response.TemporaryFile;
                        if (Q.isEmptyOrNull(fileName))
                            return;

                        if (!this.model.value) {
                            Q.notifyError("Please select a model first!");
                            return;
                        }

                        AccountModelTargetService.ImportExcel({
                            ModelCode: this.model.value,
                            FileName: fileName
                        },
                            response => {
                                Q.notifyInfo(
                                    'Inserted: ' + (response.Inserted || 0) +
                                    ', Updated: ' + (response.Updated || 0) +
                                    (response.Deleted ? (", Deleted:" + response.Deleted) : ""));

                                if (response.ErrorList != null && response.ErrorList.length > 0) {
                                    Q.alert('<pre style="max-height: 500; overflow-y: scroll">' + response.ErrorList.join('\r\n') + '</pre>', {
                                        htmlEncode: false
                                    });
                                }

                                this.refresh();
                            });
                    }
                });
            }
        }

        protected expandToLevel(level: number) {
            var items = this.view.getItems();
            for (var item of items) {
                Serenity.SlickTreeHelper.setCollapsedFlag(item,
                    level == 0 || (level > 0 && item.Level >= level));
            }
            this.view.setItems(items, true);
        }

        protected getItemCssClass(item: MyItem, index: number) {
            var klass = super.getItemCssClass(item, index);
            if (this.activeRow != null && index != this.activeRow) {
                var activeItem = this.itemAt(this.activeRow) as MyItem;
                if (!activeItem || !item || !item.TargetCode || !Q.startsWith(activeItem.TargetCode, item.TargetCode))
                    klass += " inactive";
            }
            return klass;
        }

		getParentId(x: MyItem) {
			if (x.TargetCode == "-1")
				return null;

			if (x.Level <= 1)
				return "-1";

			var s = "";
			for (var i = 1; i < x.Level; i++) {
				if (i > 1)
					s += "/";
				s += x["Code" + i];
			}

			return s;
		}

		gridPersistanceFlags() {
			var flags = super.gridPersistanceFlags();
			flags.sortColumns = false;
			return flags;
		}

		getButtons() {
			var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            Q.first(buttons, x => x.cssClass === "export-xlsx-button").onClick = () => {
                if (!this.model.value)
                    return;

                var dlg = new AccountPickerDialog();
                dlg.hasModelTarget = this.model.value;
                if (this.account.value)
                    dlg.value = [this.account.value];

                dlg.onSuccess = accounts => {
                    Q.postToService({
                        service: "Data/AccountModelTarget/ExportExcel",
                        request: <AccountModelTargetExportRequest>{
                            ModelCode: this.model.value,
                            AccountCodes: accounts.map(x => x.AccountCode)
                        },
                        target: "_blank"
                    });

                    return true;
                };
                dlg.dialogOpen();
            };

            buttons.push({
                hint: 'Import from XLSX',
                cssClass: 'add-file-button',
                icon: 'fa-cloud-upload',
                onClick: () => {
                }
            });

            buttons.push({
                hint: 'Delete All',
                cssClass: 'delete-all-button',
                icon: 'mdi mdi-delete-forever',
                onClick: e => {
                    if (!this.account.value) {
                        Q.notifyWarning('Please select a account first!');
                        return;
                    }

                    Q.confirm('Delete all records for this model/account?', () => {
                        AccountModelTargetService.DeleteAll({
                            ModelCode: this.model.value,
                            AccountCode: this.account.value
                        }, response => {
                            this.pendingChanges = {};
                            Q.notifySuccess("Deleted all records for selected model/account.");
                            this.refresh();
                        });
                    });
                },
                separator: true
            });

			buttons.push({
				title: 'Save Changes',
                cssClass: 'apply-changes-button disabled',
                icon: 'fa fa-floppy-o',
				onClick: e => this.saveClick(),
				separator: true
            });

            buttons.push({
                title: 'Reset Changes',
                cssClass: 'reset-changes-button disabled',
                icon: 'fa-undo',
                onClick: e => {
                    this.pendingChanges = {};
                    this.refresh();
                }
            });

            buttons.push({
                title: 'Approve Changes',
                cssClass: 'approve-changes-button',
                icon: 'fa fa-check text-green',
                onClick: e => {
                    Workflow.ApprovalQueueService.Approve({
                        WorkflowInstanceId: this.pendingResponse.WorkflowInstanceId
                    },
                        response => {
                            Q.notifyInfo("Changes are approved.");
                            this.refresh();
                        }
                    );
                }
            });

            buttons.push({
                title: 'Reject Changes',
                cssClass: 'reject-changes-button',
                icon: 'fa fa-times text-red',
                onClick: e => {
                    Workflow.ApprovalQueueService.Approve({
                        WorkflowInstanceId: this.pendingResponse.WorkflowInstanceId,
                        Reject: true
                    },
                        response => {
                            Q.notifyInfo("Changes are rejected.");
                            this.refresh();
                        }
                    );
                }
            });

			return buttons;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            if (!Authorization.hasPermission('DataAdmin:AccountModelTarget')) {
                this.toolbar.findButton('delete-all-button').toggleClass('disabled', true);
                this.toolbar.findButton('add-file-button').toggleClass('disabled', true);
            }

            this.toolbar.findButton('approve-changes-button').hide();
            this.toolbar.findButton('reject-changes-button').hide();
        }

		getGridCanLoad() {
			var modelAndAccount = !Q.isEmptyOrNull(this.model.value) &&
                !Q.isEmptyOrNull(this.account.value);

			if (!modelAndAccount) {
				this.view.setItems([], true);
				return false;
			}

			return super.getGridCanLoad();
		}

		onViewSubmit() {
            if (!super.onViewSubmit()) {
                this.preventSubmit > 0 && this.preventSubmit--;
				return false;
            }

            var request = this.view.params as Serenity.ListRequest;
			request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[ModelTargetRow.Fields.ModelCode] = this.model.value;

			if (this.preventSubmit > 0) {
				this.preventSubmit--;
				this.view.setItems(this.view.getItems(), true);
				this.view.refresh();
				this.slickGrid.invalidate();
				return false;
			}

			return true;
		}

        private searchText: string;

        protected createQuickSearchInput() {
            
			Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text, done) => {
				this.searchText = Select2.util.stripDiacritics(text || '').toLowerCase();
                this.view.setItems(this.view.getItems(), true);
                done && done(true);
            });
        }

        private copyTargetToMyItem(amt: AccountModelTargetRow, item: MyItem, values: boolean) {
            if (values) {
                item.Nominal = amt.Nominal;
                item.LowerLimit = amt.LowerLimit;
                item.LowerWarning = amt.LowerWarning;
                item.AccountModelTargetId = amt.AccountModelTargetId;
		        item.Target = amt.Target;
		        AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => item[t] = amt[t]);
                item.UpperLimit = amt.UpperLimit;
                item.UpperWarning = amt.UpperWarning;
            }

            for (var k of Object.keys(amt)) {
                var name = (k || "").toLowerCase();
                if (name == "modeltypecode" || name == "targetcode" || name == "level" || name == "defaultdisplayorder" || name == "siblingdisplayorder" ||
                    name == "nominal" || name == "lowerlimit" || name == "lowerwarning" || name == "accountmodeltargetid" || name == "target" ||
                    name == "upperlimit" || name == "upperwarning" ||
                    TiltRegex.test(name) ||
                    (Q.startsWith(name, "code") && !isNaN(parseInt(name.substr(4)))) ||
                    (Q.startsWith(name, "name") && !isNaN(parseInt(name.substr(4)))))
                    continue;

                item[k] = amt[k];
            }
        }

        resetState(): void {
            this._byParentId = null;
            this.pendingChanges = {};
            this.activeRow = null;
            this.focusToKey = null;
            this.focusToKeys = null;
            this.setButtonStates();
            this.pendingApproval = false;
            this.pendingResponse = {};
        }

        applyAccountModelTargets(model: ModelRow, accountModelTargets: AccountModelTargetRow[],
            approvalResponse: AccountModelTargetIsPendingApprovalResponse) {

            this.pendingApproval = approvalResponse.WorkflowInstanceId != null;
            this.pendingResponse = approvalResponse;

            var items = this.view.getItems();

            this.view.beginUpdate();
            try {

                if (accountModelTargets != null) {

                    for (var amt of accountModelTargets) {
                        var item = this.view.getItemById(amt.TargetCode);
                        if (item != null) {
                            this.copyTargetToMyItem(amt, item, true);
                            this.view.updateItem(item.TargetCode, item);
                        }
                    }
                }

                if (approvalResponse && approvalResponse.Targets) {
                    for (var target of approvalResponse.Targets) {
                        var item = this.view.getItemById(target.TargetCode);
                        if (item != null) {
                            saveOrig(item);
                            this.copyTargetToMyItem(target, item, true);
                            this.pendingChanges[target.TargetCode] = target;
                            this.view.updateItem(item.TargetCode, item);
                        }
                    }
                }
            }
            finally {
                this.view.endUpdate();
            }

            this.cascadeSums(null, true);

            if (this.view.sortBy != null &&
                this.view.sortBy.length > 1 &&
                this.view.sortBy[0] == "DefaultDisplayOrder") {
                var items = this.view.getItems();
                var order = 0;
                var itemOrder: Q.Dictionary<number> = {};
                for (var item of items)
                    itemOrder[item.TargetCode] = order++;
                items.sort((a, b) => {
                    var va = this.hasNominalOrTilt(a) ||
                        a.LowerLimit != null ||
                        a.UpperLimit != null ||
                        a.LowerWarning != null ||
                        a.UpperWarning != null;
                    var vb = this.hasNominalOrTilt(b) ||
                        b.LowerLimit != null ||
                        b.UpperLimit != null ||
                        b.LowerWarning != null ||
                        b.UpperWarning != null;
                    if (va && vb || (!va && !vb))
                        return itemOrder[a.TargetCode] - itemOrder[b.TargetCode];
                    else if (va)
                        return -1;
                    else
                        return 1;
                });
                items = Serenity.TreeGridMixin.applyTreeOrdering(items,
                    x => x.TargetCode, x => this.getParentId(x));
                Serenity.SlickTreeHelper.setIndents(items, x => x.TargetCode, this.getParentId.bind(this), false);
                this.view.setItems(items, true);

                this.checkPendingValues();
            }
        }

        insertRoot(items: ModelTargetRow[], model: ModelRow) {
            items.splice(0, 0, {
                TargetCode: "-1",
                Level: 0,
                Code1: model.ModelCode,
                Name1: model.Name
            });
        }

        onViewProcessData(response: Serenity.ListResponse<MyItem>) {
            response = super.onViewProcessData(response);
            this.resetState();

            if (this.model.value) {
                var model = ModelRow.getLookup().itemById[this.model.value];

                if (model)
                    this.insertRoot(response.Entities, model);

                if (this.account.value) {
                    AccountModelTargetService.IsPendingApproval({
                        ModelCode: this.model.value,
                        AccountCode: this.account.value,
                        Details: true
                    },
                        approvalResponse => {
                            AccountModelTargetService.List({
                                EqualityFilter: <AccountModelTargetRow>{
                                ModelCode: this.model.value,
                                    AccountCode: this.account.value
                                }
                            },
                                response => {
                                    this.applyAccountModelTargets(model, response.Entities, approvalResponse);
                                });
                        });
                }
			}

			return response;
		}

		markupReady() {
			super.markupReady();

            this.cascadeSums(null, false);
            this.checkPendingValues();
		}

		usePager() {
			return false;
		}

        private getCode(item: MyItem) {
			if (item.TargetCode == "-1")
				return item.Code1;

			return (item["Code" + item.Level] || '');
        }

		private getName(item: MyItem) {
			if (item.TargetCode == "-1")
				return item.Name1;

			return (item["Name" + item.Level] || '');
		}

		private isLeaf(item: MyItem) {
			if (item.TargetCode == "-1")
				return false;

			var children = this.byParentId[item.TargetCode];
			if (children && children.length)
				return false;

			return true;
		}

        private isEditableNominalTilt(item: MyItem) {
            if (item.TargetCode == "-1")
                return false;

            return true;
		}

		private hasNominalOrTilt(item: MyItem) {
			if (item.Nominal != null)
				return true;

			return Q.any(AccountModelTargetGrid.tiltNames(this.options.modelCode), t => item[t] != null);
        }

        protected getPersistanceKey() {
            return super.getPersistanceKey + ":" + this.options.modelCode;
        }

        protected getPropertyItems() {
            var items = Q.deepClone(super.getPropertyItems());

            var data = Q.getRemoteData("Data.AccountModelTargetCustomization");
            var customization = data[(this.options.modelCode || "").toLowerCase()];
            if (!customization || !customization.Fields)
                return items;

            for (var i = items.length - 1; i >= 0; i--) {
                var item = items[i];
                var field = customization.Fields[item.name.toLowerCase()];
                if (!field)
                    continue;

                if (field.Remove) {
                    items.splice(i, 1);
                    continue;
                }

                if (field.DisplayName)
                    item.title = field.DisplayName;
            }

            return items;
        }

        protected canClearItem(item: AccountModelTargetRow) {
            if (item.TargetCode == "-1")
                return false;

            if (item.LowerLimit == null &&
                item.UpperLimit == null &&
                item.LowerWarning == null &&
                item.UpperWarning == null &&
                (!this.isEditableNominalTilt(item) || (item.Nominal == null &&
                !Q.any(AccountModelTargetGrid.tiltNames(this.options.modelCode), t => item[t] != null))))
                return false;

            return true;
        }

        protected checkPendingValues() {
            this.view.beginUpdate();
            try {
                var keys = Object.keys(this.pendingChanges);
                for (var k of keys) {
                    var pending = this.pendingChanges[k];
                    var item = this.view.getItemById(k);
                    if (!item)
                        continue;

                    var orig = item.__orig;
                    if (!orig)
                        continue;

                    var fields = Object.keys(pending);
                    for (var field of fields) {
                        if (pending[field] === orig[field] ||
                            (pending[field] === null && orig[field] === undefined) ||
                            (pending[field] === undefined && orig[field] === null))
                            delete pending[field];
                    }

                    if (Object.keys(pending).length === 0) {
                        delete this.pendingChanges[k];
                        delete item.__orig;
                        this.view.updateItem(item.TargetCode, item);
                    }
                }
            }
            finally {
                this.view.endUpdate();
            }
        }

		protected getColumns() {
            var columns = super.getColumns();

            var otherReadOnly = !Authorization.hasPermission('DataAdmin:AccountModelTarget');
            var tiltReadOnly = !Authorization.hasPermission('DataAdmin:AccountModelTargetTilt');
            var allReadOnly = otherReadOnly && tiltReadOnly;

            var targetCodeFormat = this.itemLink(this.getEntityType(), this.getIdProperty(), ctx => Q.htmlEncode(this.getCode(ctx.item)));
            Q.first(columns, x => x.field == "TargetCode").format = ctx => {
                if ((ctx.item as ModelTargetRow).TargetCode == "-1")
                    return Q.htmlEncode(this.getCode(ctx.item));

                return targetCodeFormat(ctx);
            };
            Q.first(columns, x => x.field == "TargetName").format = ctx => Q.htmlEncode(this.getName(ctx.item));
            Q.first(columns, x => x.field == "TargetPath").format = ctx => Q.htmlEncode(ctx.item.TargetCode == "-1" ? "" : ctx.item.TargetCode);

            Q.first(columns, x => x.field == "FocusTo").format = ctx => {
                var targetCode = (ctx.item as ModelTargetRow).TargetCode;
                if (targetCode == "-1")
                    return "";

                return '<a class="inline-action focus-to" title="Focus on this row"><i class="fa fa-crosshairs ' + 
                    (this.focusToKey === targetCode ? 'text-red' : 'text-gray') + '"></i></a>';
            };

            Q.first(columns, x => x.field == "ExpandCollapseDescendants").format = ctx => {
                var item = ctx.item as ModelTargetRow;
                var children = this.byParentId[item.TargetCode];
                if (!children || !children.length)
                    return "";

                if (!item['_collapsed'] && !Q.any(children, c => {
                    var cc = this.byParentId[c.TargetCode];
                    return cc && cc.length > 0;
                })) {
                    return "";
                }

                var anyCollapse = item['_collapsed'] || Q.any(children, c => {
                    var cc = this.byParentId[c.TargetCode];
                    return cc && cc.length > 0 && !!c['_collapsed'];
                });
                
                return '<a class="inline-action expand-collapse-descendants" title="' + 
                    (anyCollapse ? "expand-descendants" : "collapse-descendants") +
                    '"><i class="mdi ' + (anyCollapse ? "mdi-expand-all-outline" : "mdi-collapse-all-outline") + ' text-tool-icon"></i></a>';
            };

            Q.first(columns, x => x.field == "ClearValues").format = ctx => {
                var item = ctx.item as MyItem;
                if (this.pendingApproval || allReadOnly || !this.canClearItem(item))
					return "";

				return '<a class="inline-action clear-values" title="clear values"><i class="fa fa-eraser text-tool-icon"></i></a>'; 
            };

            var canClearItem = this.canClearItem.bind(this);
            Q.first(columns, x => x.field == "ClearValuesForAll").format = ctx => {
                var item = ctx.item as MyItem;
                var descendants = this.getDescendants(item);
                if (this.pendingApproval || allReadOnly || !descendants.length ||
                    (!canClearItem(item) && !Q.any(this.getDescendants(item), canClearItem)))
                    return "";

                return '<a class="inline-action clear-values-for-all" title="clear values of all descendants"><i class="mdi mdi-delete-sweep text-tool-icon"></i></a>';
            };

			Q.first(columns, x => x.field == "Level").format = ctx => {
				var item = ctx.item as MyItem;
				var level = item.Level;
				if (!level || level < 1 || level > 10)
					return "";

				var model = ModelRow.getLookup().itemById[this.model.value];
				if (!model)
					return "";

				return level.toString();
			};

			Q.first(columns, x => x.field == "LevelName").format = ctx => {
				var item = ctx.item as MyItem;
				var level = item.Level;
				if (!level || level < 1 || level > 10)
					return "";

				var model = ModelRow.getLookup().itemById[this.model.value];
				if (!model)
					return "";

				return Q.htmlEncode(model['LevelName' + level] || '');
            };

            var factor = (value: number) => value == null ? value : (this.isPercent ? (value * 100) : value);

            var doubleFormat = (ctx: Slick.FormatterContext) => {
                return '<input type="text" class="' + inputClass(ctx, "decimalQ use-factor align-right", true) +
                    '" data-field="' + ctx.column.field + '" value="' + (ctx.value == null ? '' : Q.formatNumber(factor(ctx.value), d6)) + '"/>';
            }

            var doubleEditor = (ctx: Slick.FormatterContext) => {

                var item = ctx.item as MyItem;
                if (this.pendingApproval || otherReadOnly || item.TargetCode == "-1") {
                    var value = factor(ctx.value);

                    if (isDirty(ctx.item, ctx.column.field)) {
                        if (this.pendingApproval && this.showOriginal)
                            return '<span style="color: blue" title="New value: ' + Q.attrEncode(Q.formatNumber(value, d6)) + '">' +
                                Q.htmlEncode(Q.formatNumber(factor(ctx.item.__orig[ctx.column.field]), d6)) + '</span>';
                        return '<span style="color: red" title="Old value: ' + Q.attrEncode(Q.formatNumber(value, d6)) + '">' + Q.htmlEncode(Q.formatNumber(factor(ctx.item.__orig[ctx.column.field]), d6)) + '</span>';
                    }

                    return Q.htmlEncode(Q.formatNumber(value, d6));
                }

				return doubleFormat(ctx);
			};

            var nominalTiltEditor = (ctx: Slick.FormatterContext) => {
                var isTilt = ctx.column && TiltRegex.test((ctx.column as Slick.Column).field);
                if (!this.pendingApproval && (((isTilt && !tiltReadOnly) || (!isTilt && !otherReadOnly))) &&
                    this.isEditableNominalTilt(ctx.item)) {
                    return doubleFormat(ctx);
                }

                var value = factor(ctx.value);

                if (isDirty(ctx.item, ctx.column.field)) {
                    if (this.pendingApproval && this.showOriginal)
                        return '<span style="color: blue" title="New value: ' + Q.attrEncode(Q.formatNumber(value, d6)) + '">'
                            + Q.htmlEncode(Q.formatNumber(factor(ctx.item.__orig[ctx.column.field]), d6)) + '</span>';

                    return '<span style="color: red" title="Old value: ' + Q.attrEncode(Q.formatNumber(factor(ctx.item.__orig[ctx.column.field]), d6)) + '">'
                        + Q.htmlEncode(Q.formatNumber(value, d6)) + '</span>';
				}

                return Q.htmlEncode(Q.formatNumber(value, d6));

			};

            Q.first(columns, x => x.field == "Nominal").format = nominalTiltEditor;
			AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t =>
                Q.first(columns, x => x.field == t).format = nominalTiltEditor);

            Q.first(columns, x => x.field == "Target").format = ctx => {
                var value = factor(ctx.value);
				if (isDirty(ctx.item, ctx.column.field)) {
					return '<span style="color: red">' + Q.htmlEncode(Q.formatNumber(value, d6)) + '</span>';
				}

                return Q.htmlEncode(Q.formatNumber(value, d6));
			};

			Q.first(columns, x => x.field == "LowerLimit").format = doubleEditor;
			Q.first(columns, x => x.field == "UpperLimit").format = doubleEditor;
			Q.first(columns, x => x.field == "LowerWarning").format = doubleEditor;
            Q.first(columns, x => x.field == "UpperWarning").format = doubleEditor;

			return columns;
		}

        protected clearItemValues(item: AccountModelTargetRow) {
            var pending = this.pendingChanges[item[this.getIdProperty()]];
            if (!pending)
                this.pendingChanges[item[this.getIdProperty()]] = pending = {};

            saveOrig(item);

            if (this.isEditableNominalTilt(item)) {
                if (Q.Authorization.hasPermission("DataAdmin:AccountModelTarget"))
                    pending.Nominal = item.Nominal = null;
                if (Q.Authorization.hasPermission("DataAdmin:AccountModelTargetTilt"))
                    AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(x => pending[x] = item[x] = null);
            }

            if (Q.Authorization.hasPermission("DataAdmin:AccountModelTarget")) {
                pending.LowerLimit = item.LowerLimit = null;
                pending.UpperLimit = item.UpperLimit = null;
                pending.LowerWarning = item.LowerWarning = null;
                pending.UpperWarning = item.UpperWarning = null;
            }
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as MyItem;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('focus-to')) {
                    if (this.focusToKey === item.TargetCode) {
                        this.focusToKey = null;
                        this.focusToKeys = null;
                    }
                    else {
                        this.focusToKey = item.TargetCode;
                        this.focusToKeys = {};
                        this.focusToKeys["-1"] = true;
                        this.focusToKeys[item.TargetCode] = true;
                        for (var x of this.getParents(item))
                            this.focusToKeys[x.TargetCode] = true;
                        for (var x of this.getDescendants(item))
                            this.focusToKeys[x.TargetCode] = true;
                    }

                    this.view.refresh();
                    this.slickGrid.invalidate();
                }
                else if (target.hasClass("expand-collapse-descendants")) {
                    var descendants = this.getDescendants(item);
                    var anyChildrenExpanded = target.children('i').hasClass('mdi-collapse-all-outline');

                    this.view.beginUpdate();
                    try {
                        Serenity.SlickTreeHelper.setCollapsed([item], false);
                        Serenity.SlickTreeHelper.setCollapsed(descendants, anyChildrenExpanded);
                    }
                    finally {
                        this.view.endUpdate();
                    }
                    this.slickGrid.invalidate();
                }
                else if (target.hasClass("clear-values")) {

                    this.clearItemValues(item);
                    this.cascadeSums(item, false);
                    this.checkPendingValues();
                    this.setButtonStates();
                    this.view.refresh();
                    this.slickGrid.invalidate();
                }
                else if (target.hasClass("clear-values-for-all")) {
                    Q.confirm('Clear values for this target and all its descendants?', () => {
                        var descendants = this.getDescendants(item);
                        for (var d of descendants) {
                            if (!this.canClearItem(d))
                                continue;
                            this.clearItemValues(d);
                            this.cascadeSums(d, false);
                        }

                        if (item.TargetCode != "-1") {
                            this.clearItemValues(item);
                            this.cascadeSums(item, false);
                        }
                        this.checkPendingValues();
                        this.setButtonStates();
                        this.view.refresh();
                        this.slickGrid.invalidate();
                    });
                }
            }
        }

		private linesWithValues: boolean;
        private leavesOnly: boolean;
        private showOriginal: boolean;

        protected initQuickCheck(w: Serenity.BooleanEditor) {
            var label = w.element.closest('.quick-filter-item').css('margin-right', '15px').find('.quick-filter-label');
            label
                .css({
                    'cursor': 'pointer',
                    'font-size': '13px',
                    'color': 'var(--body-text)',
                    'font-weight': 'normal'
                })
                .html(Q.htmlEncode(label.text().trim()) + ' <i class="fa fa-square-o" style="color: var(--input-border); font-size: 20px; position: relative; top: 3px; text-align: left; margin-left: 2px; width: 20px"></i>')
                .click(() => {
                    w.value = !w.value;
                    w.element.triggerHandler('change');
                    this.updateQuickCheck(w);
                });
            w.element.hide();
            this.updateQuickCheck(w);
        }

        protected updateQuickCheck(w: Serenity.BooleanEditor) {
            var i = w.element.closest('.quick-filter-item').find('.quick-filter-label').find('i');
            i.toggleClass('fa-square-o', !w.value);
            i.toggleClass('fa-check-square-o', w.value);
            i.toggleClass('text-green', w.value);
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            var filter = Q.tryFirst(filters, x => x.field == "LinesWithValues") as Serenity.QuickFilter<Serenity.BooleanEditor, any>;
            if (filter) {
                filter.type = Serenity.BooleanEditor;
                filter.handler = h => {
                    this.linesWithValues = h.active = !!h.value;
                };
                filter.init = (w) => this.initQuickCheck(w);
                filter.loadState = (w, s) => {
                    w.value = !!s;
                    this.updateQuickCheck(w);
                }
                filter.saveState = (w) => w.value;
            }

            filter = Q.tryFirst(filters, x => x.field == "LeavesOnly") as Serenity.QuickFilter<Serenity.BooleanEditor, any>;
            if (filter) {
                filter.type = Serenity.BooleanEditor;
                filter.handler = h => {
                    this.leavesOnly = h.active = !!h.value;
                };
                filter.init = (w) => this.initQuickCheck(w);
                filter.loadState = (w, s) => {
                    w.value = !!s;
                    this.updateQuickCheck(w);
                }
                filter.saveState = (w) => w.value;
            }

            filter = Q.tryFirst(filters, x => x.field == "ShowOriginal") as Serenity.QuickFilter<Serenity.BooleanEditor, any>;
            if (filter) {
                filter.type = Serenity.BooleanEditor;
                filter.handler = h => {
                    this.showOriginal = h.active = !!h.value;
                    this.slickGrid.invalidate();
                    h.handled = true;
                };
                filter.init = (w) => {
                    this.initQuickCheck(w);
                    w.element.closest('.quick-filter-item').hide();
                }
                filter.loadState = (w, s) => { }
                filter.saveState = (w) => null;
            }

            return filters;
        }

        protected createQuickFilters() {
            super.createQuickFilters();

            $("<h4 class='filters-cap grid-sub-title' style='flex: 1 1 100%'>Filters</h4>")
                .insertBefore(this.quickFiltersDiv && this.quickFiltersDiv.length ?
                    this.quickFiltersDiv : this.slickContainer);
        }

		private preventSubmit: number = 0;

        protected quickFilterChange(e: JQueryEventObject) {
            this.preventSubmit++;
            super.quickFilterChange(e);
        }

		protected onViewFilter(item: MyItem): boolean {
            if (!super.onViewFilter(item)) {
                return false;
            }

            if (!Serenity.SlickTreeHelper.filterById(item, this.view, x => this.getParentId(x)))
                return false;

			if (this.leavesOnly && item.TargetCode != "-1" && !this.isLeaf(item))
				return false;

            if (this.focusToKey != null &&
                this.focusToKeys != null &&
                !this.focusToKeys[item.TargetCode])
                return false;

			if (this.linesWithValues) {
				if (item.Nominal == null &&
					!Q.any(AccountModelTargetGrid.tiltNames(this.options.modelCode), t => item[t] != null) &&
					item.Target == null &&
					item.LowerLimit == null &&
					item.UpperLimit == null &&
					item.LowerWarning == null &&
					item.UpperWarning == null)
					return false;
			}

			if (!this.searchText)
				return true;

            return this.containsSearchText(item) || Q.any(this.getDescendants(item), x => this.containsSearchText(x));
        }

		private containsSearchText(item: MyItem): boolean {
            return Select2.util.stripDiacritics(this.getCode(item)).toLowerCase().indexOf(this.searchText) >= 0 ||
                Select2.util.stripDiacritics(this.getName(item)).toLowerCase().indexOf(this.searchText) >= 0;
        }

		private _byParentId: Q.Grouping<MyItem>;

        private get byParentId() {
            if (this._byParentId)
                return this._byParentId;

            this._byParentId = Q.toGrouping(this.view.getItems(), x => this.getParentId(x));
            return this._byParentId;
        }

		private getDescendants(item: MyItem): MyItem[] {
			let result: MyItem[] = [];
            let byParentId = this.byParentId;
            let stack = [item];
            while (stack.length > 0) {
                let i = stack.pop();
                let children = byParentId[i.TargetCode];
                if (!children)
                    continue;

                for (let child of children) {
                    result.push(child);
                    stack.push(child);
                }
            }

            return result;
		}

		private getParents(item: MyItem, targetClass: boolean = false): MyItem[] {
			let result: MyItem[] = [];
			while (true) {
				var parentId = this.getParentId(item);
				if (parentId == null || (!targetClass && parentId == '-1'))
					return result;
				item = this.view.getItemById(parentId);
				if (item == null)
					return result;
				result.push(item);
			}
		}

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row) as MyItem;

            var input = $(e.target);
            var field = input.data('field');

            var effective = item[field];
            if (effective != null && this.isPercent && input.hasClass('use-factor'))
                effective = effective * 100;

            var oldInputVal: string;
            if (input.hasClass("integer"))
                oldInputVal = Q.formatNumber(effective, '0');
            else if (input.hasClass("decimalQ")) {
                oldInputVal = Q.formatNumber(effective, d6);
            }
            else
                oldInputVal = effective as string;

            var inputText = Q.trimToNull(input.val());

            var value;
            if (input.hasClass('nullable') &&
                inputText == null) {
                value = null;
            }
            else if (input.hasClass('decimalQ')) {
                var m = Q.parseDecimal(inputText || '0');
                if (m == null || isNaN(m)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldInputVal);
                    input.focus();
                    return;
                }

                if (this.isPercent && input.hasClass('use-factor'))
                    m = m / 100;

                if (field == "LowerWarning" && m != null && m < (item.LowerLimit || m)) {
                    Q.notifyError("Lower Warning has to be greater than or equal to Lower Limit!");
                    input.val(oldInputVal);
                    input.focus();
                    return;
                }

                if (field == "UpperWarning" && m != null && m > (item.UpperLimit || m)) {
                    Q.notifyError("Upper Warning has to be less than or equal to Upper Limit!");
                    input.val(oldInputVal);
                    input.focus();
                    return;
                }

                if (field == "LowerLimit" && m != null && m > item.Target) {
                    Q.notifyError("Lower Limit has to be less than or equal to Target!");
                    input.val(oldInputVal);
                    input.focus();
                    return;
                }

                if (field == "UpperLimit" && m != null && m < item.Target) {
                    Q.notifyError("Upper Limit has to be greater than or equal to Target!");
                    input.val(oldInputVal);
                    input.focus();
                    return;
                }

                value = m;
            }
            else if (input.hasClass("integer")) {
                var i = Q.parseInteger(inputText || '0');
                if (isNaN(i) || i > 1073741823 || i < -1073741824 || (i < 0 && !TiltRegex.test(field))) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldInputVal);
                    input.focus();
                    return;
                }

                value = i;
            }
            else if (input.hasClass("dateQ")) {
                var d = Q.parseDate(inputText || '');
                if (d == null || isNaN(d) || d === false) {
                    Q.notifyError(Q.text('Validation.Date'), '', null);
                    input.val(oldInputVal);
                    input.focus();
                    return;
                }
                value = d;
            }
            else
                value = inputText;

            var pending = this.pendingChanges[item[this.getIdProperty()]];
            if (!pending)
                this.pendingChanges[item[this.getIdProperty()]] = pending = {};

            pending[field] = value;
            saveOrig(item);
            item[field] = value;
            item.__override = item.__override || {};
            item.__override[field] = true;

            var newInputVal = value;
            if (input.hasClass("nullable") &&
                value == null)
                newInputVal = null;
            else if (input.hasClass("integer")) { 
                newInputVal = Q.formatNumber(value, '0');
            }
            else if (input.hasClass('decimalQ')) {
                if (this.isPercent && input.hasClass('use-factor'))
                    value = value * 100;
                newInputVal = Q.formatNumber(value, d6);
            }
			else if (input.hasClass("dateQ"))
				newInputVal = Q.formatDate(value);

			input.val(newInputVal).addClass('dirty');

            this.cascadeSums(item, false);
            this.checkPendingValues();
			this.setButtonStates();
			this.view.refresh();
			this.slickGrid.invalidate();
		}

		private hasPendingChanges() {
			return Object.keys(this.pendingChanges).length > 0;
		}

		private setButtonStates() {
            this.toolbar.findButton('apply-changes-button').toggleClass('disabled',
                !this.hasPendingChanges()).toggle(!this.pendingApproval);
            this.toolbar.findButton('reset-changes-button').toggleClass('disabled',
                !this.hasPendingChanges()).toggle(!this.pendingApproval);
            this.toolbar.findButton('add-file-button').toggle(!this.pendingApproval);
            this.toolbar.findButton('delete-all-button').toggle(!this.pendingApproval);
            this.toolbar.findButton('approve-changes-button').toggle(!!this.pendingApproval && !!this.pendingResponse && !!this.pendingResponse.CanApprove);
            this.toolbar.findButton('reject-changes-button').toggle(!!this.pendingApproval && !!this.pendingResponse && !!this.pendingResponse.CanReject);
            var flt = this.tryFindQuickFilter(Serenity.Widget, "ShowOriginal");
            flt && flt.element.closest('.quick-filter-item').toggle(!!this.pendingApproval);
		}

		protected getSlickOptions() {
			var opt = super.getSlickOptions();
			opt.enableAsyncPostRender = true;
			opt.asyncPostRenderDelay = -1;
			opt.enableAsyncPostRenderCleanup = true;
			return opt;
		}

        private static _tiltNames: Q.Dictionary<string[]> = {};

		public static tiltNames(modelCode: string): string[] {
            if (!AccountModelTargetGrid._tiltNames[modelCode]) {
                var data = Q.getRemoteData("Data.AccountModelTargetCustomization");
                var customization = data[(modelCode || "").toLowerCase()];
                var tiltNames = Q.getColumns("Data.AccountModelTarget")
                    .filter(x => TiltRegex.test(x.name))
                    .map(x => x.name);
                tiltNames = tiltNames.filter(t => {
                    if (customization == null || customization.Fields == null)
                        return true;

                    var field = customization.Fields[t.toLowerCase()];

                    return !field || !field.Remove;
                });

                AccountModelTargetGrid._tiltNames[modelCode] = tiltNames;
			}
			return AccountModelTargetGrid._tiltNames[modelCode];
		}

		private cascadeSums(forceUpdate?: MyItem, setOverrideFlags?: boolean) {
			var sums: Q.Dictionary<MyItem> = {};

            var items = this.view.getItems();
            if (setOverrideFlags) {
                for (var item of items) {
                    if (!this.isLeaf(item))
                        item.__override = {};
                }
            }

			var startFromItems = items.filter(x => {
				if (forceUpdate != null &&
					forceUpdate.TargetCode == x.TargetCode)
					return true;

				return this.hasNominalOrTilt(x) && this.isEditableNominalTilt(x);
			});

			var parentOfAnyStart: Q.Dictionary<boolean> = {};
			startFromItems.forEach(x => this.getParents(x).forEach(z => parentOfAnyStart[z.TargetCode] = true));

			for (var item of startFromItems) {

				if (parentOfAnyStart[item.TargetCode])
                    continue;

                if (setOverrideFlags && !this.isLeaf(item)) {
                    if (item.Nominal != null && item.Nominal !== 0)
                        item.__override.Nominal = true;

                    AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
                        if (item[t] != null && item[t] > 0)
                            item.__override[t] = true;
                    });
                }

				var current = item;
				while (true) {
					var parentId = this.getParentId(current);
					if (parentId == null)
						break;

					current = this.view.getItemById(parentId);
					if (current == null)
						break;

					var sum = sums[current.TargetCode];
					if (sum == null) {
						sums[current.TargetCode] = sum = {};
					}

					if (item.Nominal != null)
						sum.Nominal = (sum.Nominal || 0) + item.Nominal;

					AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
						if (item[t] != null)
							sum[t] = (sum[t] || 0) + item[t];
					});
				}
			}

			for (var targetCode of Object.keys(sums)) {
				var sum = sums[targetCode];
				var item = this.view.getItemById(targetCode);
				if (!item)
					continue;

                var override: Q.Dictionary<boolean>;
                item.__override = override = item.__override || {};

				if (item.Nominal != sum.Nominal ||
					Q.any(AccountModelTargetGrid.tiltNames(this.options.modelCode), t => item[t] != sum[t])) {
					if (targetCode != "-1")
						saveOrig(item);

                    if (setOverrideFlags) {
                        if (item.Nominal != null && 
                            item.Nominal > sum.Nominal &&
                            Math.abs(item.Nominal - sum.Nominal) >= 0.000001)
                            override.Nominal = true;

                        AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
                            if (item[t] != null &&
                                Math.abs(item[t] - sum[t]) >= 0.000001)
                                override[t] = true;
                        });
                    }

                    var pendingChanges = false;

                    if (!override['Nominal'] || item.Nominal == null) {
                        if (item.Nominal !== sum.Nominal) {
                            item.Nominal = sum.Nominal;
                            pendingChanges = true;
                        }
                        override['Nominal'] = false;
                    }
                    else {
                        for (var x of this.getParents(item, true)) {
                            sums[x.TargetCode].Nominal = (sums[x.TargetCode].Nominal || 0) + ((item.Nominal || 0) - (sum.Nominal || 0));
                        }
                    }

                    AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
                        if (!override[t] || item[t] == null) {
                            if (item[t] !== sum[t]) {
                                item[t] = sum[t];
                                override[t] = false;
                                pendingChanges = true;
                            }
                        }
                        else {
                            for (var x of this.getParents(item, true)) {
                                sums[x.TargetCode][t] = (sums[x.TargetCode][t] || 0) + ((item[t] || 0) - (sum[t] || 0));
                            }
                        }
                    });

                    if (targetCode != "-1" && pendingChanges) {
						var pending = this.pendingChanges[item.TargetCode];
						if (pending == null)
							this.pendingChanges[item.TargetCode] = pending = {};

						pending.Nominal = item.Nominal;
						AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => pending[t] = item[t]);
					}

					this.view.updateItem(item.TargetCode, item);
				}
			}

			for (var item of items) {
				var target: number = null;

				if (item.Nominal != null)
					target = (target || 0) + item.Nominal;

				AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
					if (item[t] != null)
						target = (target || 0) + item[t];
				});

                if (target != item.Target) {
                    if (item.TargetCode != "-1")
						saveOrig(item);

					item.Target = target;

                    if (item.TargetCode != "-1") {
						var pending = this.pendingChanges[item.TargetCode];
						if (pending == null)
							this.pendingChanges[item.TargetCode] = pending = {};

						pending.Nominal = item.Nominal;
						pending.Target = target;
						AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => pending[t] = item[t]);
					}

					this.view.updateItem(item.TargetCode, item);
				}
			}

			this.setButtonStates();
		}

		private saveClick() {

			var items = this.view.getItems();

			for (var x of items) {
				if (x.TargetCode == "-1")
					continue;

                if (x.LowerWarning != null && x.LowerLimit != null && x.LowerWarning < x.LowerLimit) {
					Q.notifyError(x.TargetCode + ": Lower Warning has to be greater than or equal to Lower Limit!");
					return;
				}

                if (x.UpperWarning != null && x.UpperLimit != null && x.UpperWarning > x.UpperLimit) {
					Q.notifyError(x.TargetCode + ": Upper Warning has to be less than or equal to Upper Limit!");
					return;
				}

                if (x.LowerLimit != null && x.Target != null && x.LowerLimit > x.Target) {
					Q.notifyError(x.TargetCode + ": Lower Limit has to be less than or equal to Target!");
					return;
				}

				if (x.UpperLimit != null && x.Target != null && x.UpperLimit < x.Target) {
					Q.notifyError(x.TargetCode + ": Upper Limit has to be greater than or equal to Target!");
					return;
				}
			}

			if (Object.keys(this.pendingChanges).length === 0)
				return;

			var save = () => {
				AccountModelTargetService.BatchUpdate({
					AccountCode: this.account.value,
                    ModelCode: this.model.value,
                    Targets: Object.keys(this.pendingChanges)
                        .map(x => this.view.getItemById(x))
                        .filter(x => x.TargetCode != "-1")
						.map(x => {
							var z: AccountModelTargetRow = {
								TargetCode: x.TargetCode,
								Nominal: x.Nominal,
								LowerLimit: x.LowerLimit,
								UpperLimit: x.UpperLimit,
								LowerWarning: x.LowerWarning,
								UpperWarning: x.UpperWarning
							};

							AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => z[t] = x[t]);
							return z;
						})
                },
                    response => {
					    this.pendingChanges = {};
                        Q.notifySuccess("Changes saved.");
                        this.refresh();
                    },
                    {
                        onError: (response) => {
                            if (response && response.Error && response.Error.Code == "ApprovalRequired") {
                                Q.notifyWarning(response.Error.Message);
                                this.refresh();
                                return;
                            }
                            Q.ErrorHandling.showServiceError(response.Error);
                        }
                    });
            };

			var root = this.view.getItemById("-1");
			//if (root && root.Target && root.Target != 100) {
			//	Q.confirm("Total target (" + root.Target + ") is not equal to 100, continue?",
			//		() => save());
			//}
			//else {
			//	save();
			//}
                save();
        }

        editItem(entityOrId: object) {
            if (typeof (entityOrId) == "string") {
                if (!this.model.value)
                    return;

                if (!this.account.value)
                    return;

                var item = this.view.getItemById(entityOrId);
                if (!item)
                    return;

                if (!item.ModelCode)
                    return;

                AccountModelTargetService.List({
                    EqualityFilter: <AccountModelTargetRow>{
                        TargetCode: item.TargetCode,
                        ModelCode: this.model.value,
                        AccountCode: this.account.value
                    },
                    ColumnSelection: Serenity.ColumnSelection.Details
                }, response => {
                    var dlg = new AccountModelTargetDialog({
                        modelCode: this.options.modelCode
                    });

                    dlg.element.find('.delete-button,.clone-button' + (this.pendingApproval ? ',.apply-changes-button,.save-and-close-button,.edit-button' : ''))
                        .css({
                            'visibility': 'hidden',
                            'width': '0px',
                            'padding': 0
                        });

                    var entity: AccountModelTargetRow;
                    if (response.Entities && response.Entities.length) {
                        entity = response.Entities[0];
                    }
                    else {
                        if (this.pendingApproval)
                            return;
                        entity = {
                            TargetCode: item.TargetCode,
                            ModelCode: this.model.value,
                            AccountCode: this.account.value
                        }
                    }

                    entity.TargetName = this.getName(item);
                    dlg.editableNominalTilt = !this.pendingApproval && this.isEditableNominalTilt(item);

                    var pending = this.pendingChanges[item[this.getIdProperty()]];
                    if (pending) {
                        for (var k of Object.keys(pending)) {
                            entity[k] = pending[k];
                        }
                    }

                    dlg.loadEntityAndOpenDialog(entity);
                    Serenity.SubDialogHelper.bindToDataChange(dlg, this, (p1, dci) => {
                        var entityId;
                        if (dci.type == "create")
                            entityId = dci.entityId;
                        else 
                            entityId = entity.AccountModelTargetId;
                        if (!entityId)
                            return;
                        AccountModelTargetService.Retrieve({
                            EntityId: entityId,
                            ColumnSelection: Serenity.RetrieveColumnSelection.details
                        }, r => {
                            this.copyTargetToMyItem(r.Entity, item, true);
                            delete this.pendingChanges[entityId.toString()];
                            this.view.updateItem(item.TargetCode, item);
                            this.cascadeSums(item, true);
                            this.checkPendingValues();    
                            this.setButtonStates();
                            this.view.refresh();
                            this.slickGrid.invalidate();
                        });
                    });
                })
            }
        }
	}

	function saveOrig(item: any) {
		if (!item.__orig)
			item.__orig = Q.deepClone(item);
		return item;
	}

	function isDirty(item: any, field: string) {
        return item.__orig && item.__orig[field] !== item[field] && !(
            (item.__orig[field] === null && item[field] === undefined) ||
            (item.__orig[field] === undefined && item[field] === null));
	}

	function inputClass(ctx: Slick.FormatterContext, klass: string, nullable?: boolean) {
		return 'edit ' + (klass || '') + (nullable ? ' nullable' : '') + (isDirty(ctx.item, ctx.column.field) ? ' dirty' : '');
	}

	function integerEditFormat(nullable?: boolean) {
		return (ctx: Slick.FormatterContext) => {
			return '<input type="text" class="' + inputClass(ctx, "integer align-right", nullable) +
				'" data-field="' + ctx.column.field + '" value="' + (ctx.value == null ? '' : Q.formatNumber(ctx.value, '0')) + '"/>';
		}
    }
}